import { replaceDomainForCacheKey, ReportingFunction, createFetchyeResource } from '@americanexpress/fetchye-amex';
import { type RootStateOrAny } from 'react-redux';
import { createSelector } from 'reselect';
import { FetchyeOptions, ignoreHeadersByKey } from 'fetchye';
import { v4 } from 'uuid';
import { MODULE_NAME, ONE_DATA_FUNCTION_NAME } from '../constants/moduleConstants';

const cacheKey = 'oneData';
const ignoreHeaders = [
  'one-data-correlation-id',
];

export const getOneDataUrl = (state: RootStateOrAny) => state.getIn(['config', 'faasApiUrl']);
export const getOneDataFunctionUrl = (functionName: string) => createSelector(
  getOneDataUrl,
  (oneDataUrl) => `${oneDataUrl}/${functionName}`
);

export const reportingFunction: ReportingFunction = ({
  key,
  error,
  options,
}) => ({
  moduleID: MODULE_NAME,
  component: ONE_DATA_FUNCTION_NAME,
  fetch: {
    url: key,
    status: error?.status,
    correlationId: options.headers?.['one-data-correlation-id'] || '',
  },
});

const generateParams = (options: FetchyeOptions<Record<string, unknown>>, { select }: { select: (selector: unknown) => string }) => [
  select(getOneDataFunctionUrl(ONE_DATA_FUNCTION_NAME)),
  {
    ...options,
    method: 'POST',
    headers: {
      ...options?.headers,
      credentials: 'include',
      'content-type': 'application/json',
      'one-data-correlation-id': v4(),
    },
    mapKeyToCacheKey: replaceDomainForCacheKey(cacheKey),
    mapOptionsToKey: ignoreHeadersByKey(ignoreHeaders),
  },
  reportingFunction,
];

export const [
  useArticlesHook, loadArticlesThunk,
] = createFetchyeResource(generateParams);
